<template>
  <div class="pagination">
    <button type="button" :class="[{'disabled':current == pages},'btn-prev']" @click="setcurrent(current+1)">></button>
    <ul class="zel-pager">
      <li v-for="page in pageslist" :class="{'disabled':current == 1,'active': current==page}" @click="setcurrent(page)">
        <a href="javascript:void(0);">{{page}}</a>
      </li>
    </ul>
    <button type="button" :class="[{'disabled':current == 1},'btn-prev']" @click="setcurrent(current- 1)"><</button>
    <span class="pagedetail fr">共{{pages}}页，每页显示{{pagesize}}条，共{{total}}条</span>
  </div>
</template>
<script>
  export default {
    name:"Pagination",
    data() {
      return {
        current: this.currentpage
      }
    },
    props: {
      total: {//数据总条数
        type:Number,
        default:0
      },
      pagesize: {//每页显示条数
        type:Number,
        default:20
      },
      currentpage: {
        type:Number,
        default:1
      },
      pagegroup: {
        type:Number,
        default:5,
        validator:function(showpages){
          return showpages % 2 ===1 ? showpages : showpages+1
        }
      }
    },
    computed: {
      pages() {
        return Math.ceil(this.total / this.pagesize)
      },
      pageslist() {
        let len = this.pages,
          pageslist= [],//所有页数列表
          grouplist = [],//当前显示页数列表
          count = Math.floor(this.pagegroup / 2);//当前页面前后显示几页
        while(len--){
          pageslist.push(this.pages-len)
        };
        if(this.pages <=this.pagegroup){
          return pageslist;
        }
        let startpage;
        if(this.current <= count+1){
          startpage=0;
        }else if(this.current>=this.pages-count){
          startpage = this.pages-this.pagegroup;
        }else{
          startpage = this.current-count-1
        }
        grouplist = pageslist.splice(startpage,this.pagegroup)
        return grouplist
      }
    },
    watch:{
      current(newval,oldval) {
        console.log("新值："+newval)
        console.log("旧值："+oldval)
      }
    },
    methods:{
      setcurrent(page) {
        if(page > 0 && page < this.pages + 1){
          this.current = page;
          this.$emit('pagechange',this.current)
        }

      }
    }
  }
</script>
<style lang="less">
  .pagination {
    padding-top:20px;
    overflow: hidden;
    margin: 0 auto;
    /*width: 100%;*/
    line-height:32px;
    height: 32px;
  button{
    width: 32px;
    height: 32px;
    border: 1px solid #E1E7F6;
    float: right;
    margin-left: -1px;
    text-align: center;
    cursor: pointer;
    color:#666;
    background-color: #fff;
  }
  button:focus {
    outline: none;
  }
  button.disabled{
    color:#c0c4cc;
    cursor:not-allowed;
  }
  .zel-pager{
    display:inline-block;
    float:right;
    li {
      width: 30px;
      height: 30px;
      border: 1px solid #E1E7F6;
      line-height:30px;
      float: left;
      margin-left: -1px;
      text-align: center;
      cursor: pointer;
      color:#666;

      a{
        color:#666;
      }

    }
    li.active {
      background-color: #64B9FF;
      a {
        color: #fff;
      }
    }
  }
  .pagedetail{
    line-height:32px;
    color:#aaa;
    margin-right:10px;
  }

  }

</style>




// WEBPACK FOOTER //
// src/libs/pagination.vue